/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userDetails.internal

import features.userDetails.models.UserDetailsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class UserDetailsRequest : NetworkRequest() {

    suspend fun getUserDetails(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<UserDetailsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserDetailsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
